export default __webpack_public_path__ + "static/aykunna-bb8c5a878160d164b11a60cbe153f768.mp3";